import IMG5 from "../assets/imageCaptcha.png";
import IMG6 from "../assets/messengerApp.png";

/** Portfolio projects aligned with résumé — tutorial clones removed */
export const PROJECTS = [
  {
    id: "messaging",
    image: IMG6,
    title: "Real-Time Messaging Platform",
    summary:
      "Full-stack messaging app with authentication and real-time communication. PostgreSQL schema and query tuning for sub-200ms message delivery, automated tests, and API security controls.",
    stack: ["Node.js", "React", "PostgreSQL", "REST APIs"],
    github: "https://github.com/darthjeditt/TraisMessengerApp",
    demo: null,
  },
  {
    id: "ocr",
    image: IMG5,
    title: "Machine Learning OCR Model",
    summary:
      "Python + TensorFlow CAPTCHA OCR with iterative training and evaluation. Improved accuracy ~40% over baseline through data and hyperparameter tuning, with documented experiments for reproducibility.",
    stack: ["Python", "TensorFlow", "Computer Vision"],
    github:
      "https://github.com/darthjeditt/Machine-Learning-OCR-Model-Reading-Captchas",
    demo: null,
  },
];
